import React, { useState, useEffect, useRef } from 'react'
import DateDropdown from '../Utils/DateDropdown'
import Notification from '../Utils/Notification'
import TestimonialsPanel from '../TestimonialsPanel'
import { withAuth } from '../AuthContext'
import { withSearch } from '../SearchContext'
import { withRouter } from 'react-router-dom'
import { gaEvents } from '../../analytics/events'
import { shouldTranslateTo } from '../../utils/utils'
import styled from 'styled-components'
import {
  ActionButtons,
  CustomSelect,
  FormSelect,
  Title,
  Subtitle,
  TextArea,
} from '../Utils/CustomClasses'

const ContainerBox = styled.div`
  padding: 0 36px 55px 36px;
  background-color: transparent;

  @media (max-width: 799px) {
    padding: 0 25px 25px 25px;
  }
`

const OnboardingTitle = styled(Title)`
  font-family: 'Open Sans', sans-serif;
`

const OnboardingSubtitle = styled(Subtitle)`
  font-family: 'Open Sans', sans-serif;
`

const ProceedButton = styled(ActionButtons)`
  background-color: #0bac5d;
  margin: 26px auto 0;
`

const ErrorWrapper = styled.div`
  margin: 30px 0 0;
  height: 50px;
  text-align: center;
`

const OnboardingError = styled.label`
    background-color: #ffff00;
    color: #ff0000;
    padding: 5px 10px;
    border-radius: 5px;
    margin: 0 4vw;
}
`

const TestimonialsWrapper = styled.div`
  margin: 80px 0 0;
`

const BioOnboarding = ({ data, countriesNice, onUpdate, onComplete }) => {
  const [pageText, setPageText] = useState([])
  const [loading, setLoading] = useState(false)
  const [philosophy, setPhilosophy] = useState('')
  const [philosophyError, setPhilosophyError] = useState(false)
  const [introduction, setIntroduction] = useState('')
  const [introductionError, setIntroductionError] = useState(false)
  const [interest, setInterest] = useState('')
  const [interestError, setInterestError] = useState(false)
  const [travelPrefs, setTravelPrefs] = useState('')
  const [travelPrefsError, setTravelPrefsError] = useState(false)
  const [homestayPrefs, setHomestayPrefs] = useState('')
  const [homestayPrefsError, setHomestayPrefsError] = useState(false)
  const [bucketListCountries, setBucketListCountries] = useState(false)
  const [defaultBucketListCountries, setDefaultBucketListCountries] =
    useState(false)
  const [bucketListCountriesError, setBucketListCountriesError] =
    useState(false)
  const [dobDay, setDobDay] = useState(false)
  const [dobMonth, setDobMonth] = useState(false)
  const [dobYear, setDobYear] = useState(false)
  const [dobDayError, setDobDayError] = useState(false)
  const [dobMonthError, setDobMonthError] = useState(false)
  const [dobYearError, setDobYearError] = useState(false)
  const [existingDay, setExistingDay] = useState(null)
  const [existingMonth, setExistingMonth] = useState(null)
  const [existingYear, setExistingYear] = useState(null)
  const [error, setError] = useState('')
  const [travelPrefsOptions, setTravelPrefsOptions] = useState([
    {
      value: 'solo',
      label: 'I’m a solo traveler',
    },
    {
      value: 'partner-friend',
      label: 'I travel with a partner or friend',
    },
    {
      value: 'seek-travel-buddies',
      label:
        'I’d like to find people to plan trips with or meet up with while traveling',
    },
    {
      value: 'all',
      label: 'All of the above',
    },
  ])
  const [homestayPrefsOptions, setHomestayPrefsOptions] = useState([
    {
      value: 'become-host',
      label: 'I’m interested in becoming a Host',
    },
    {
      value: 'book-homestays',
      label: 'I’m interested in booking a homestay',
    },
    {
      value: 'not-interested',
      label: 'I’m not interested in homestays',
    },
    {
      value: 'not-sure-yet',
      label: 'I’m not sure yet',
    },
  ])

  useEffect(() => {
    gaEvents.eventGeneric(
      'page_load',
      'add-bio-page-loaded',
      data.auth.user.id + ' - add bio - page loaded'
    )

    const language = shouldTranslateTo()
    const getPageText = (pageValue, languageValue) => {
      axios
        .get(`/api/page-text/${pageValue}/${languageValue}`)
        .then((response) => {
          let pageText = response.data.map((textItem) => {
            return textItem.text
          })

          setPageText(pageText)
        })
        .catch((err) => {
          console.log('Error getting page text: ', err)
        })
    }

    console.log('data.auth.user: ' + JSON.stringify(data.auth.user))

    setIntroduction(data.auth.user.introduction && data.auth.user.introduction)
    setInterest(data.auth.user.interest && data.auth.user.interest)
    setPhilosophy(data.auth.user.philosophy && data.auth.user.philosophy)
    setTravelPrefs(data.auth.user.travelPrefs && data.auth.user.travelPrefs)

    setHomestayPrefs(
      data.auth.user.homestayPrefs && data.auth.user.homestayPrefs
    )

    if (data.auth.user.dob) {
      console.log('data.auth.user.dob: ' + data.auth.user.dob)
      const dobArr = data.auth.user.dob.split('-')
      console.log('dobArr: ' + JSON.stringify(dobArr))
      setExistingDay(dobArr[2])
      setExistingMonth(dobArr[1])
      setExistingYear(dobArr[0])
      console.log('existingDay: ' + existingDay)
      console.log('existingMonth: ' + existingMonth)
      console.log('existingYear: ' + existingYear)
    }

    console.log(
      'data.auth.user.bucketListCountries: ' +
        JSON.stringify(data.auth.user.bucketListCountries)
    )

    console.log('countriesNice: ' + JSON.stringify(countriesNice))

    setBucketListCountries(
      data.auth.user.bucketListCountries &&
        data.auth.user.bucketListCountries.map(function (bucketCountry) {
          return bucketCountry
        })
    )

    setDefaultBucketListCountries(
      data.auth.user.bucketListCountries &&
        countriesNice &&
        data.auth.user.bucketListCountries.map(function (bucketCountry) {
          console.log('a')
          return countriesNice.find((c) => c.value === bucketCountry)
        })
    )

    getPageText('profile-bio', language)
  }, [])

  useEffect(() => {
    const travelPrefsArray = [
      {
        value: 'solo',
        label: pageText[1],
      },
      {
        value: 'partner-friend',
        label: pageText[2],
      },
      {
        value: 'seek-travel-buddies',
        label: pageText[3],
      },
      {
        value: 'all',
        label: pageText[4],
      },
    ]

    const homestayPrefsArray = [
      {
        value: 'become-host',
        label: pageText[5],
      },
      {
        value: 'book-homestays',
        label: pageText[6],
      },
      {
        value: 'not-interested',
        label: pageText[7],
      },
      {
        value: 'not-sure-yet',
        label: pageText[8],
      },
    ]

    console.log('travelPrefsArray: ' + JSON.stringify(travelPrefsArray))
    console.log('homestayPrefsArray: ' + JSON.stringify(homestayPrefsArray))

    setTravelPrefsOptions(travelPrefsArray)
    setHomestayPrefsOptions(homestayPrefsArray)

    console.log('travelPrefsOptions: ' + JSON.stringify(travelPrefsOptions))
    console.log('travelPrefsOptions: ' + JSON.stringify(travelPrefsOptions))

    console.log(
      'Object.keys(travelPrefsOptions).length: ' +
        JSON.stringify(Object.keys(travelPrefsOptions).length)
    )
  }, [pageText])

  const handleInputChange = (e) => {
    const target = e.target
    const name = target.name

    console.log('name: ' + name)

    setError('')
    setPhilosophyError(false)
    setIntroductionError(false)
    setInterestError(false)

    switch (name) {
      case 'introduction':
        setIntroduction(e.target.value)
        break
      case 'interest':
        setInterest(e.target.value)
        break
      case 'philosophy':
        setPhilosophy(e.target.value)
        break
      default:
        break
    }
  }

  const handleTravelPrefsChange = (e) => {
    console.log('e: ' + JSON.stringify(e))
    console.log('e.value: ' + JSON.stringify(e.value))
    setError('')
    setTravelPrefs(e.value)
    handleUpdateOnFly()
  }

  const handleHomestaysChange = (e) => {
    console.log('e: ' + JSON.stringify(e))
    console.log('e.value: ' + JSON.stringify(e.value))
    setError('')
    setHomestayPrefs(e.value)
    handleUpdateOnFly()
  }

  const handleCountriesChange = (option) => {
    setError('')
    const countriesData = option.map(function (option) {
      return option.value
    })
    setBucketListCountries(countriesData)
    setDefaultBucketListCountries(countriesData)
    handleUpdateOnFly()
  }

  const updateDobDay = (value) => {
    console.log('updateDobDay')
    setDobDayError(false)
    setError(null)
    setDobDay(value)
    handleUpdateOnFly()
  }

  const updateDobMonth = (value) => {
    console.log('updateDobMonth')
    setDobMonthError(false)
    setError(null)
    setDobMonth(value)
  }

  const updateDobYear = (value) => {
    setDobYearError(false)
    setError(null)
    setDobYear(value)
  }

  const handleUpdateOnFly = () => {
    const userData = {
      philosophy: philosophy,
      introduction: introduction,
      interest: interest,
      travelPrefs: travelPrefs,
      homestayPrefs: homestayPrefs,
      bucketListCountries: bucketListCountries,
    }

    data.auth.updateUser(userData)
  }

  const handleSubmit = () => {
    setPhilosophyError(false)
    setIntroductionError(false)
    setInterestError(false)
    setTravelPrefsError(false)
    setHomestayPrefsError(false)
    setBucketListCountriesError(false)

    if (!philosophy) {
      setPhilosophyError(true)
      setError(pageText[9])
      return
    }

    if (!introduction) {
      setIntroductionError(true)
      setError(pageText[10])
      return
    }

    if (!interest) {
      setInterestError(true)
      setError(pageText[11])
      return
    }

    if (!travelPrefs) {
      setTravelPrefsError(true)
      setError(pageText[12])
      return
    }

    if (!homestayPrefs) {
      setHomestayPrefsError(true)
      setError(pageText[13])
      return
    }

    if (!bucketListCountries) {
      if (!defaultBucketListCountries) {
        setBucketListCountriesError(true)
        setError(pageText[14])
        return
      } else {
        setBucketListCountries(defaultBucketListCountries)
      }
    }

    if (!dobDay) {
      setDobDayError(true)
      setError(pageText[15])
      return
    }

    if (!dobMonth) {
      setDobMonthError(true)
      setError(pageText[16])
      return
    }

    if (!dobYear) {
      setDobYearError(true)
      setError(pageText[17])
      return
    }

    setLoading(true)

    const userData = {
      philosophy: philosophy,
      philosophyStatus: 'completed',
      introduction: introduction,
      introductionStatus: 'completed',
      interest: interest,
      interestStatus: 'completed',
      travelPrefs: travelPrefs,
      homestayPrefs: homestayPrefs,
      bucketListCountries: bucketListCountries,
      dob: `${dobYear}-${dobMonth}-${dobDay}`,
      circleIntroStatus: 'pending',
    }

    console.log('userData: ' + JSON.stringify(userData))

    data.auth
      .updateUser(userData)
      .then(() => {
        /*
        Notification({
          type: SUCCESS,
          message: `Profile info added`,
        })
        onUpdate('dc-comp')
        */

        setTimeout(function () {
          onComplete('dc')
        }, 1000)
      })
      .catch((e) => {
        setLoading(false)
        Notification({
          data: e,
        })
      })
  }

  if (
    pageText.length === 0 ||
    loading ||
    Object.keys(travelPrefsOptions).length === 0 ||
    Object.keys(homestayPrefsOptions).length === 0
  ) {
    return (
      <div className="card-body text-center">
        <div
          className="spinner-border onboarding-spinner"
          style={{ marginTop: '100px' }}
          role="status"
        >
          <span className="sr-only">{pageText[18]}</span>
        </div>
      </div>
    )
  }
  return (
    <ContainerBox>
      <OnboardingTitle
        center
        color="#ff9900"
        size="34px"
        sizemd="34px"
        sizesm="34px"
        margin="10px 0 0"
        dangerouslySetInnerHTML={{
          __html: `Step 1`,
        }}
      ></OnboardingTitle>

      <OnboardingSubtitle
        center
        color="#fff"
        size="20px"
        sizesm="20px"
        weight="700"
        margin="20px 0 50px"
        dangerouslySetInnerHTML={{
          __html: `${pageText[19]}`,
        }}
      />

      <OnboardingSubtitle
        center
        color="#fff"
        size="18px"
        sizesm="18px"
        weight="400"
        margin="10px 0 15px"
        dangerouslySetInnerHTML={{
          __html: `${pageText[20]}`,
        }}
      />

      <TextArea
        id="philosophy"
        name="philosophy"
        rows="5"
        required
        margin="0 0 40px 0"
        placeholder={pageText[21]}
        value={philosophy}
        className={philosophyError && 'empty-box'}
        onChange={(e) => handleInputChange(e)}
        onFocus={() => handleUpdateOnFly()}
      />

      {/* INTRODUCE YORSELF */}
      <OnboardingSubtitle
        center
        color="#fff"
        size="18px"
        margin="0 0 16px 0px"
        weight="400"
        dangerouslySetInnerHTML={{
          __html: `${pageText[22]}`,
        }}
      />
      <TextArea
        id="introduction"
        name="introduction"
        className={introductionError && 'empty-box'}
        rows="5"
        margin="0 0 40px 0"
        placeholder={pageText[23]}
        value={introduction}
        onChange={(e) => handleInputChange(e)}
        onFocus={() => handleUpdateOnFly()}
      />
      {/* Interests */}
      <OnboardingSubtitle
        center
        color="#fff"
        size="18px"
        margin="0 0 16px 0px"
        weight="400"
        dangerouslySetInnerHTML={{
          __html: `${pageText[24]}`,
        }}
      />
      <TextArea
        id="interest"
        name="interest"
        rows="5"
        margin="0 0 40px 0"
        className={interestError && 'empty-box'}
        placeholder={pageText[25]}
        value={interest}
        onChange={(e) => handleInputChange(e)}
        onFocus={() => handleUpdateOnFly()}
      />

      <OnboardingSubtitle
        center
        color="#ff9900"
        size="20px"
        sizesm="20px"
        weight="600"
        margin="10px 0 50px"
        dangerouslySetInnerHTML={{
          __html: `${pageText[26]}`,
        }}
      />

      <OnboardingSubtitle
        center
        color="#fff"
        size="18px"
        sizesm="18px"
        weight="400"
        margin="20px 0 15px"
        dangerouslySetInnerHTML={{
          __html: `${pageText[27]}`,
        }}
      />

      <CustomSelect
        width="-webkit-fill-available"
        placeholder={pageText[28]}
        defaultValue={travelPrefsOptions.find(
          (option) => option.value === travelPrefs
        )}
        className={travelPrefsError && 'error-border'}
        isDisabled={false}
        isLoading={false}
        isRtl={false}
        isSearchable={true}
        name="travelprefs"
        margin="0 0 70px 0"
        marginsm="0 0 70px 0"
        options={travelPrefsOptions}
        onChange={(e) => handleTravelPrefsChange(e)}
      />

      <OnboardingSubtitle
        center
        color="#fff"
        size="18px"
        sizesm="18px"
        weight="400"
        margin="20px 0 15px"
        dangerouslySetInnerHTML={{
          __html: `${pageText[29]}`,
        }}
      />

      <CustomSelect
        width="-webkit-fill-available"
        placeholder={pageText[28]}
        defaultValue={homestayPrefsOptions.find(
          (option) => option.value === homestayPrefs
        )}
        className={homestayPrefsError && 'error-border'}
        isDisabled={false}
        isLoading={false}
        isRtl={false}
        isSearchable={true}
        name="homestayprefs"
        margin="0 0 70px 0"
        marginsm="0 0 70px 0"
        options={homestayPrefsOptions}
        onChange={(e) => handleHomestaysChange(e)}
      />

      <OnboardingSubtitle
        center
        color="#fff"
        size="18px"
        sizesm="18px"
        weight="400"
        margin="20px 0 15px"
        dangerouslySetInnerHTML={{
          __html: `${pageText[30]}`,
        }}
      />

      <FormSelect
        width="100%"
        id="bucketListCountries"
        name="bucketListCountries"
        height="auto"
        margin="0 0 70px 0"
        marginsm="0 0 70px 0"
        className={bucketListCountriesError && 'error-border'}
        placeholder={pageText[31]}
        isDisabled={false}
        isLoading={false}
        isClearable={false}
        isRtl={false}
        isSearchable={true}
        options={countriesNice}
        required
        onChange={handleCountriesChange}
        isMulti
        defaultValue={defaultBucketListCountries}
      />

      <OnboardingSubtitle
        center
        color="#fff"
        size="18px"
        sizesm="18px"
        weight="400"
        margin="20px 0 15px"
        dangerouslySetInnerHTML={{
          __html: `${pageText[32]}`,
        }}
      />

      <DateDropdown
        updateDobDay={updateDobDay}
        updateDobMonth={updateDobMonth}
        updateDobYear={updateDobYear}
        dobDayError={dobDayError}
        dobMonthError={dobMonthError}
        dobYearError={dobYearError}
        existingDay={existingDay}
        existingMonth={existingMonth}
        existingYear={existingYear}
      />

      <ErrorWrapper>
        {error && <OnboardingError>{error}</OnboardingError>}
      </ErrorWrapper>

      <ProceedButton
        type="submit"
        padding="10px 60px"
        margin="46px 10vw 26px"
        fontsize="16px"
        onClick={() => {
          handleSubmit()
        }}
      >
        {pageText[33]}
      </ProceedButton>

      {/* Testimonials */}
      <TestimonialsWrapper>
        <TestimonialsPanel
          color={'transparent'}
          textcolor={'#ffffff'}
          showintro={false}
          numbertoshow={1}
          step={1}
        />
      </TestimonialsWrapper>
    </ContainerBox>
  )
}

export default withRouter(withSearch(withAuth(BioOnboarding)))
